import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import './index.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import { SolanaWalletProvider } from './Web/SolanaWalletProvider';
import { BrowserRouter } from 'react-router-dom';
import { WalletProvider } from './context/WalletContext';

window.Buffer = window.Buffer || Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <SolanaWalletProvider>
      <WalletProvider>
        <App />
      </WalletProvider>
    </SolanaWalletProvider>
  </BrowserRouter>
);
